import { createContext, useContext, useState, useEffect } from 'react';
import { getSessionToken, setSessionToken, getStoredSessionToken } from './sessionUtils';

const SessionContext = createContext();

export function SessionProvider({ children, initialSessionToken, subdomain }) {
  const [sessionToken, setSessionTokenState] = useState(initialSessionToken);

  useEffect(() => {
    if (initialSessionToken) {
      setSessionToken(initialSessionToken);
      setSessionTokenState(initialSessionToken);
    }
  }, [initialSessionToken]);

  const value = {
    sessionToken,
    setSessionToken: (token) => {
      setSessionToken(token);
      setSessionTokenState(token);
    },
  };

  return (
    <SessionContext.Provider value={value}>
      {children}
    </SessionContext.Provider>
  );
}

export function useSession() {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error('useSession must be used within a SessionProvider');
  }
  return context;
} 